import { registerTenant, TenantId } from '~/tenants/common/registry';
import { TwtOrderSchema } from '~/tenants/twt/model/TwtOrder';
import { twtTenantOptions } from '~/tenants/twt/register';

/**
 * twt2 — Twist Tours V2, the production clone of twt provisioned via
 * the tenant-setup pipeline (create-tenant + promote-tenant-config).
 *
 * Reuses twt's order/customer/provider classes, forms, performables
 * and packages WHOLESALE via twtTenantOptions() — no copied files.
 * Only identity fields are overridden:
 *   - id twt2 / name "Twist Tours V2"
 *   - domain 'twt2.invalid': deliberately inert (no live domain and
 *     .invalid can never resolve). The tenant is reached via the
 *     ?tenant=twt2 query param that tenant_optional() already supports
 *     (worker/admin/src/tenants/common/util.server.ts).
 *   - brands stripped: twt's maverick brand carries a LIVE domain
 *     (maverick.twisttours.com); keeping it here would make
 *     getTenantByDomain() resolution order-dependent between twt and
 *     twt2.
 * Locations, timezones and everything else are inherited from twt.
 *
 * The DB_twt2 wrangler binding is intentionally NOT added here — the
 * create-tenant CLI adds it at provision time.
 */
export default function registerTwt2() {
  registerTenant(TenantId.TWIST_TOURS_V2, TwtOrderSchema, {
    ...twtTenantOptions(),
    name: 'Twist Tours V2',
    domain: 'twt2.invalid',
    brands: undefined,
  });
}
